import { Grid, Container, Box, Tab, IconButton } from '@mui/material';
import { GridColDef, DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react'
import { useAppContext } from '../../../libs/app-core/AppContext';
import { Toast } from '../../../libs/app-core/Toast';
import { linear_v, linear_item, linear_content_style } from '../../../libs/linear-layout/LinearLayout';
import AppBarTabs from '../../components/AppBarTabs';
import TabPage from '../../components/TabPage';
import UcDgvCustomPagination from '../../components/UcDgvCustomPagination';
import UcDgvCustomToolbar from '../../components/UcDgvCustomToolbar';
import { render_ToolTipCell, DGV_LOCAL_TEXT } from '../../components/UIHelper';
import { UniFunc } from '../../dao/UniFunc';
import { SpwkToHisInfo } from './SpwkToHisInfo';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { GovRow } from '../../export_spwk/GovRow';
import Label from '../../../libs/rhf-mui/ui/Label';

type Props = {
  /** 左側選單 Focus 的轉檔結果 */
  CurrInfo: SpwkToHisInfo | undefined;

  /* 篩選: 特作編號 (此轉檔結果，繼續篩選，只看到指定特作) */
  CurrUniFunc: UniFunc | null;
}


const UcGovRowView = ({ CurrInfo, CurrUniFunc, ...props }: Props) => {
  const ctx = useAppContext();

  const [CurrTabIndex, set_CurrTabIndex] = useState("tab_Table");

  let data_list = CurrInfo?.ExportBundle?.AllGovRowList ?? [];
  if (CurrUniFunc != null) {
    data_list = data_list.filter(x => x.作業編號 === CurrUniFunc.func_code);
  }

  const json = JSON.stringify(data_list, null, 4);

  return (
    <Grid {...linear_v}>

      {/* 上方控制區 */}
      <Grid {...linear_item}>
        <Container >
          {render_Tabs()}
        </Container>
      </Grid>

      {/* 下方內容區 */}
      <Grid {...linear_item} flex={1} sx={{}}>
        {render_TabControl()}
      </Grid>

    </Grid>
  )

  function render_Tabs() {
    return (
      <Container  >
        <AppBarTabs AppBarTabIndex={CurrTabIndex} set_AppBarTabIndex={set_CurrTabIndex} is_light_bg={true}>
          <Tab label="Table" value={"tab_Table"} />
          <Tab label="JSON" value={"tab_JSON"} />
        </AppBarTabs>
      </Container>
    );
  }

  function render_TabControl() {
    return (
      <Box style={linear_content_style} sx={{ height: "100%", bgcolor: "" }}>
        <TabPage tab_key={"tab_Table"} curr_tab={CurrTabIndex} sx={{ bgcolor: "", height: "100%", overflow: 'hidden' }}>
          <Box sx={{ height: "100%", bgcolor: "" }}>
            {render_DataGrid()}
          </Box>
        </TabPage>

        <TabPage tab_key={"tab_JSON"} curr_tab={CurrTabIndex} sx={{}}>
          <Container >
            <Label>{json}</Label>
          </Container>
        </TabPage>
      </Box>
    );
  }

  function render_DataGrid(): React.ReactNode {
    const columns: GridColDef<GovRow>[] = [
      { field: '作業編號', headerName: '特作', width: 70, description: '', editable: true },

      { field: '問題類別', headerName: '問題類別(章節)', width: 120, description: '', editable: true },
      { field: '問題編號', headerName: '問題編號(題號)', width: 120, description: '', editable: true },
      { field: '答題內容', headerName: '答題內容(勾選)', renderCell: render_ToolTipCell(), width: 480, description: '', editable: true, },
      { field: '答題內容_1', headerName: '答題內容_1', renderCell: render_ToolTipCell(), width: 200, description: '', editable: true, },
      { field: '答題內容_2', headerName: '答題內容_2', renderCell: render_ToolTipCell(), width: 200, description: '', editable: true, },
      { field: '答題內容_3', headerName: '答題內容_3', renderCell: render_ToolTipCell(), width: 200, description: '', editable: true, },
      { field: '答題內容_4', headerName: '答題內容_4', renderCell: render_ToolTipCell(), width: 200, description: '', editable: true, },

    ];

    const dataWithId = data_list.map((data, index) => ({ ...data, id: index + 1 }));

    return (
      <div style={linear_content_style}>
        <DataGrid
          style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
          rows={dataWithId}
          columns={columns}

          localeText={DGV_LOCAL_TEXT}// 中文

          components={{
            Toolbar: () => {
              return (<UcDgvCustomToolbar>
                <IconButton onClick={() => { Toast.Show(ctx, "More") }} ><MoreVertIcon /></IconButton>
              </UcDgvCustomToolbar>);
            },
            Pagination: () => {
              return <UcDgvCustomPagination />
            },
          }}

          density={"compact"}
          pageSize={100}
          rowsPerPageOptions={[100]}
          hideFooterSelectedRowCount
          // hideFooter

          onCellEditCommit={async ({ id, field, value }) => { }}
        />
      </div>
    );

  }


}

export default UcGovRowView